// Utilidades SEO client-side. Coherentes con la limpieza de marca del backend.

// Equivalente JS de AUTHOR_MARK_RE del backend (social_publishers.py):
// © / (c) [ separadores # · . - ] Javi Lobo / Javilobo
export const AUTHOR_MARK_RE = /(?:©|\(\s*c\s*\))[\s#·.\-–—]*jav[ií]\s*lobo/gi;

export function cleanMark(s) {
  return (s || "").replace(AUTHOR_MARK_RE, "");
}

export function buildDescription(source, limit = 200) {
  let t = cleanMark(source || "").replace(/\s+/g, " ").trim();
  if (t.length > limit) {
    t = t.slice(0, limit).replace(/[\s,.;:—–-]+$/, "") + "…";
  }
  return t;
}
